import { FC, ReactElement } from 'react'

import { ProductWithVariants } from '../../../types'
import SearchBarProductCard from '../searchBarProductCard'

import './index.css'

type SearchBarResultModelProps = {
  products: ProductWithVariants[]
  searchQuery: string
  togglePopUp: () => void
}

const SearchBarResultModel: FC<SearchBarResultModelProps> = ({ products, searchQuery, togglePopUp }): ReactElement => {
  return (
    <div className="search-result-model-inner-container fade-in">
      {window.innerWidth >= 500
        ? products.map((product, index) =>
            index < 4 ? <SearchBarProductCard searchQuery={searchQuery} key={index} product={product} togglePopUp={togglePopUp} /> : null
          )
        : products.map((product, index) =>
            index < 2 ? <SearchBarProductCard searchQuery={searchQuery} key={index} product={product} togglePopUp={togglePopUp} /> : null
          )}
    </div>
  )
}

export default SearchBarResultModel
